import { render, staticRenderFns } from "./WineListComponent.vue?vue&type=template&id=92a6ae0a&scoped=true"
import script from "./WineListComponent.vue?vue&type=script&lang=js"
export * from "./WineListComponent.vue?vue&type=script&lang=js"
import style0 from "./WineListComponent.vue?vue&type=style&index=0&id=92a6ae0a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a6ae0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92a6ae0a')) {
      api.createRecord('92a6ae0a', component.options)
    } else {
      api.reload('92a6ae0a', component.options)
    }
    module.hot.accept("./WineListComponent.vue?vue&type=template&id=92a6ae0a&scoped=true", function () {
      api.rerender('92a6ae0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/WineListComponent.vue"
export default component.exports